/* engine coupon */
(() => {
   if (window.__sovCouponBadgeEngineBooted) {
    return;
  }

  window.__sovCouponBadgeEngineBooted = true; 
  const config = {
    rootSelector: '.dt-fieldset[data-dt-payload]',
    refreshMs: 30000,
    timerMs: 1000,
    cartSyncMs: 12000,
    drawerWaitMs: 4500,
    applyWaitMs: 6500,
    discountRedirect: '/cart'
  };

  const firstRuntimeRoot = document.querySelector(config.rootSelector);

  const localeRaw =
    (firstRuntimeRoot && firstRuntimeRoot.getAttribute('data-locale')) ||
    (document.documentElement && document.documentElement.lang) ||
    'it';

  const currency =
    (firstRuntimeRoot && firstRuntimeRoot.getAttribute('data-currency')) ||
    'EUR';

  const locale = String(localeRaw).replace(/_/g, '-');

  function normalizeLocaleTag(tag) {
    try {
      const value = String(tag || '').trim().toLowerCase().replace('_', '-');
      const match = value.match(/^([a-z]{2})(?:-([a-z]{2}))?$/);
      if (!match) return '';
      return match[2] ? match[1] + '-' + match[2] : match[1];
    } catch (_) {
      return '';
    }
  }

  function getLocaleRoot() {
    let root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    if (/^\/[a-z]{2}-[a-z]{2}\/$/.test(root)) {
      return root;
    }

    const htmlLang = normalizeLocaleTag(document.documentElement && document.documentElement.lang);

    if (/^\/[a-z]{2}\/$/.test(root) && /^([a-z]{2})-[a-z]{2}$/.test(htmlLang)) {
      const langInRoot = root.slice(1, 3);
      if (htmlLang.slice(0, 2) === langInRoot) {
        return '/' + htmlLang + '/';
      }
    }

    return root.replace(/\/+$/, '/');
  }

  function buildStoreUrl(path) {
    const cleanPath = String(path || '').replace(/^\/+/, '');
    return getLocaleRoot() + cleanPath;
  }

  config.discountRedirect = buildStoreUrl('cart');

  const stateMap = new WeakMap();

  function parsePayload(root) {
    const raw = root.getAttribute('data-dt-payload');
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (_) {
      return null;
    }
  }

  function toDate(value) {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  function formatMoneyFromCents(cents) {
    const value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(value);
    } catch (_) {
      return value.toFixed(2) + ' ' + currency;
    }
  }

  function formatRemaining(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [
      String(hours).padStart(2, '0'),
      String(minutes).padStart(2, '0'),
      String(seconds).padStart(2, '0')
    ].join(':');
  }

  function getWindows(payload) {
    if (!payload || !Array.isArray(payload.Windows)) return [];
    return payload.Windows;
  }

function getActiveWindow(windows, now) {
  if (!windows.length) return null;

  for (let i = 0; i < windows.length; i += 1) {
    const win = windows[i];
    const startsAt = toDate(win.StartsAt);
    const bufferEndsAt = toDate(win.BufferEndsAt);

    if (!startsAt || !bufferEndsAt) continue;

    if (now >= startsAt && now < bufferEndsAt) {
      return win;
    }
  }

  for (let i = 0; i < windows.length; i += 1) {
    const win = windows[i];
    const startsAt = toDate(win.StartsAt);
    if (startsAt && startsAt > now) return win;
  }

  return null;
}

function getVisibleTier(windowObj, now) {
  if (!windowObj || !Array.isArray(windowObj.Tiers)) return null;

  for (let i = 0; i < windowObj.Tiers.length; i += 1) {
    const tier = windowObj.Tiers[i];
    if (!tier || tier.Hidden) continue;

    const startsAt = toDate(tier.StartsAt);
    const expiresAt = toDate(tier.ExpiresAt);

    if (startsAt && expiresAt) {
      if (now >= startsAt && now < expiresAt) return tier;
      continue;
    }

    if (!startsAt && !expiresAt) {
      return tier;
    }
  }

  return null;
}

  function getTierByCode(payload, code) {
    const target = String(code || '').trim().toUpperCase();
    if (!target || !payload || !Array.isArray(payload.Windows)) return null;

    for (let i = 0; i < payload.Windows.length; i += 1) {
      const win = payload.Windows[i];
      if (!win || !Array.isArray(win.Tiers)) continue;

      for (let j = 0; j < win.Tiers.length; j += 1) {
        const tier = win.Tiers[j];
        if (!tier || tier.Hidden) continue;

        const tierCode = String(tier.Code || '').trim().toUpperCase();
        if (tierCode && tierCode === target) return tier;
      }
    }

    return null;
  }

  function getOrCreateState(root) {
    let state = stateMap.get(root);

    if (!state) {
      state = {
        busy: false,
        payload: null,
        windowId: '',
        tier: null,
        expiresAt: null,
        lastCartCode: '',
        lastEmittedCode: '',
        firstCartSyncDone: false,
        syncPromise: null
      };
      stateMap.set(root, state);
    }

    return state;
  }

  function cleanupDeprecatedUi(root) {
    root.querySelectorAll('.dt-coupon-meta').forEach((el) => el.remove());
    root.querySelectorAll('[data-dt-coupon-code]').forEach((el) => el.remove());
    root.querySelectorAll('[data-dt-savings-amount]').forEach((el) => el.remove());
    root.querySelectorAll('.sov-coupon-apply-btn__save-label').forEach((el) => el.remove());
    root.querySelectorAll('.sov-coupon-apply-btn__save-amount').forEach((el) => el.remove());

    root.querySelectorAll('[data-dt-savings-line]').forEach((el) => {
      const wrap = el.closest('.sov-coupon-apply-btn__right');
      if (wrap) {
        wrap.remove();
      } else {
        el.remove();
      }
    });
  }

  function updateVisibility(root, visible) {
    root.setAttribute('data-dt-visible', visible ? '1' : '0');
    root.hidden = !visible;
  }

  function updatePercent(root, tier) {
    const pctEl = root.querySelector('.dt-pct');
    if (!pctEl || !tier) return;

    const percent = Number(tier.Percent || 0);
    pctEl.textContent = '-' + percent + '%';
  }

  function updateCouponTotal(root) {
    const totalEl = root.querySelector('[data-dt-coupon-total-amount]');
    if (!totalEl) return;

    const cents = Number(root.getAttribute('data-dt-coupon-total-cents') || 0);
    totalEl.textContent = formatMoneyFromCents(cents);
  }

  function updateTimer(root) {
    const state = getOrCreateState(root);
    const timerEl = root.querySelector('.dt-inline-timer');
    if (!timerEl) return;

    if (!state.expiresAt) {
      timerEl.textContent = '00:00:00';
      return;
    }

    const ms = state.expiresAt.getTime() - Date.now();
    timerEl.textContent = formatRemaining(ms);
  }

  function setSelectedTier(root, tierName) {
    root.setAttribute('data-dt-selected', tierName || '');

    root.querySelectorAll('.dt-check[data-tier]').forEach((input) => {
      input.checked = input.getAttribute('data-tier') === String(tierName || '');
    });
  }

  function setBusy(root, busy) {
    const state = getOrCreateState(root);
    state.busy = busy;

    const button = root.querySelector('.sov-coupon-apply-btn');
    const busyBox = root.querySelector('.dt-busy-msg');

    root.classList.toggle('is-busy', !!busy);

    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    if (busyBox) {
      busyBox.hidden = !busy;

      const guard = busyBox.querySelector('[data-dt-drawer-guard]');
      if (guard) guard.hidden = true;
    }
  }

  function isCartDrawerOpen() {
    const selectors = [
      'cart-drawer[open]',
      'cart-drawer.is-active',
      '.cart-drawer.is-active',
      '.cart-drawer.active',
      '.drawer.active',
      '.drawer.is-active'
    ];

    for (let i = 0; i < selectors.length; i += 1) {
      if (document.querySelector(selectors[i])) return true;
    }

    return false;
  }

  function waitForDrawerOrTimeout(timeoutMs) {
    return new Promise((resolve) => {
      if (isCartDrawerOpen()) {
        resolve(true);
        return;
      }

      const startedAt = Date.now();
      const timer = setInterval(() => {
        const opened = isCartDrawerOpen();
        const expired = Date.now() - startedAt >= timeoutMs;

        if (opened || expired) {
          clearInterval(timer);
          resolve(opened);
        }
      }, 100);
    });
  }

  async function applyDiscountCode(code) {
    const url =
      buildStoreUrl('discount/' + encodeURIComponent(code)) +
      '?redirect=' +
      encodeURIComponent(config.discountRedirect);

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('discount apply failed');
    }

    return true;
  }

  function findProductForm(root) {
    const scopes = [];
    const section = root.closest('.shopify-section');
    const main = root.closest('main');
    const body = document;

    if (section) scopes.push(section);
    if (main && scopes.indexOf(main) === -1) scopes.push(main);
    scopes.push(body);

    const selectors = [
      'product-form form[action*="/cart/add"]',
      'form[action*="/cart/add"]'
    ];

    for (let i = 0; i < scopes.length; i += 1) {
      for (let j = 0; j < selectors.length; j += 1) {
        const form = scopes[i].querySelector(selectors[j]);
        if (form) return form;
      }
    }

    return null;
  }

  function triggerNativeAddToCart(root) {
    const form = findProductForm(root);
    if (!form) {
      throw new Error('cart form not found');
    }

    const submitBtn =
      form.querySelector('button[name="add"]:not([disabled])') ||
      form.querySelector('button[type="submit"]:not([disabled])') ||
      form.querySelector('input[type="submit"]:not([disabled])');

    if (submitBtn) {
      submitBtn.click();
      return true;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return true;
    }

    form.submit();
    return true;
  }

  function dispatchCouponEvent(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
    window.dispatchEvent(new CustomEvent(name, { detail }));
  }

  function emitDiscountState(detail) {
    const payload = {
      code: detail.code || '',
      percent: Number(detail.percent || 0),
      expiresAt: detail.expiresAt || '',
      tier: detail.tier || '',
      windowId: detail.windowId || ''
    };

    document.dispatchEvent(new CustomEvent('sov:discount:applied', { detail: payload }));
    document.dispatchEvent(new CustomEvent('sov:discount:changed', { detail: payload }));
  }

  async function removeEffectiveDiscountCode() {
    const response = await fetch(buildStoreUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    });

    if (!response.ok) {
      throw new Error('discount remove failed');
    }

    return response.json().catch(() => null);
  }

  async function readEffectiveDiscountCode() {
    const response = await fetch(buildStoreUrl('cart.js') + '?ts=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return '';

    const cart = await response.json();
    let code = '';

    if (Array.isArray(cart.cart_level_discount_applications)) {
      for (let i = 0; i < cart.cart_level_discount_applications.length; i += 1) {
        const app = cart.cart_level_discount_applications[i] || {};
        if (app.code) {
          code = String(app.code).trim();
          break;
        }
        if (app.title) {
          code = String(app.title).trim();
          break;
        }
      }
    }

    if (!code && Array.isArray(cart.discount_codes)) {
      const d = cart.discount_codes.find((x) => x && x.code && x.applicable !== false);
      if (d && d.code) code = String(d.code).trim();
    }

    if (!code && Array.isArray(cart.items)) {
      outer:
      for (let i = 0; i < cart.items.length; i += 1) {
        const item = cart.items[i];
        if (!Array.isArray(item.line_level_discount_allocations)) continue;

        for (let j = 0; j < item.line_level_discount_allocations.length; j += 1) {
          const app = (item.line_level_discount_allocations[j] || {}).discount_application || {};
          if (app.code) {
            code = String(app.code).trim();
            break outer;
          }
          if (app.title) {
            code = String(app.title).trim();
            break outer;
          }
        }
      }
    }

    return code || '';
  }

  async function waitForCouponApplied(code, timeoutMs) {
    const target = String(code || '').trim();
    if (!target) return false;

    const startedAt = Date.now();

    while (Date.now() - startedAt < timeoutMs) {
      const current = await readEffectiveDiscountCode().catch(() => '');
      if (current && current.toUpperCase() === target.toUpperCase()) {
        return true;
      }

      await new Promise((resolve) => setTimeout(resolve, 350));
    }

    return false;
  }

  function buildDetailFromTier(root, tier) {
    const state = getOrCreateState(root);

    return {
      code: tier && tier.Code ? tier.Code : '',
      percent: Number((tier && tier.Percent) || 0),
      expiresAt: tier && tier.ExpiresAt ? tier.ExpiresAt : '',
      tier: tier && tier.Tier ? tier.Tier : '',
      windowId: state.windowId || ''
    };
  }

  async function syncRootWithCart(root, forcedCode) {
    const state = getOrCreateState(root);

    if (state.syncPromise && typeof forcedCode === 'undefined') {
      return state.syncPromise;
    }

    const run = (async () => {
      let effectiveCode = '';

      if (typeof forcedCode === 'string') {
        effectiveCode = forcedCode.trim();
      } else {
        effectiveCode = await readEffectiveDiscountCode().catch(() => state.lastCartCode || '');
      }

      let effectiveTier = effectiveCode ? getTierByCode(state.payload, effectiveCode) : null;

      if (effectiveTier && effectiveTier.ExpiresAt) {
        const exp = Date.parse(effectiveTier.ExpiresAt);
        if (!isNaN(exp) && Date.now() >= exp) {
          try {
            await removeEffectiveDiscountCode();
          } catch (_) {}

          effectiveCode = '';
          effectiveTier = null;
        }
      }

      if (!effectiveCode) {
        state.lastCartCode = '';

        if (state.lastEmittedCode) {
          state.lastEmittedCode = '';
          emitDiscountState({
            code: '',
            percent: 0,
            expiresAt: '',
            tier: '',
            windowId: ''
          });
        }

        setSelectedTier(root, '');
        updateVisibility(root, !!state.tier);
      } else {
        state.lastCartCode = effectiveCode;

        if (effectiveTier) {
          const normalized = String(effectiveCode).trim().toUpperCase();

          if (state.lastEmittedCode !== normalized) {
            state.lastEmittedCode = normalized;
            emitDiscountState(buildDetailFromTier(root, effectiveTier));
          }

          setSelectedTier(root, effectiveTier.Tier || '');
        } else {
          state.lastEmittedCode = String(effectiveCode).trim().toUpperCase();
          setSelectedTier(root, '');
        }

        updateVisibility(root, false);
      }

      state.firstCartSyncDone = true;
      root.style.visibility = '';

      return effectiveCode;
    })().finally(() => {
      if (state.syncPromise === run) {
        state.syncPromise = null;
      }
    });

    state.syncPromise = run;
    return run;
  }

  async function handleApplyClick(root) {
    const state = getOrCreateState(root);
    if (state.busy || !state.tier) return;

    setBusy(root, true);
    setSelectedTier(root, state.tier.Tier || '');

    const detail = {
      fieldsetId: root.id || '',
      windowId: state.windowId || '',
      WindowId: state.windowId || '',
      tier: state.tier.Tier || '',
      Tier: state.tier.Tier || '',
      code: state.tier.Code || '',
      Code: state.tier.Code || '',
      percent: Number(state.tier.Percent || 0),
      Percent: Number(state.tier.Percent || 0),
      expiresAt: state.tier.ExpiresAt || '',
      ExpiresAt: state.tier.ExpiresAt || ''
    };

    try {
      await applyDiscountCode(detail.code);
      triggerNativeAddToCart(root);

      emitDiscountState(detail);
      dispatchCouponEvent('add_to_cart_with_coupon', detail);
      dispatchCouponEvent('storeofvalues:coupon:applied', detail);

      await waitForCouponApplied(detail.code, config.applyWaitMs);
      await syncRootWithCart(root, detail.code);
      await waitForDrawerOrTimeout(config.drawerWaitMs);
    } catch (_) {
      setSelectedTier(root, '');

      emitDiscountState({
        code: '',
        percent: 0,
        expiresAt: '',
        tier: '',
        windowId: ''
      });

      await syncRootWithCart(root, '');
    } finally {
      setBusy(root, false);
    }
  }

  function wireRoot(root) {
    if (root.getAttribute('data-dt-wired') === '1') return;

    const button = root.querySelector('.sov-coupon-apply-btn');
    if (button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        handleApplyClick(root).catch(() => {});
      });
    }

    root.setAttribute('data-dt-wired', '1');
  }

  function refreshRoot(root) {
    cleanupDeprecatedUi(root);
    wireRoot(root);

    const state = getOrCreateState(root);
    const payload = parsePayload(root);
    const now = new Date();
    const windows = getWindows(payload);
    const activeWindow = getActiveWindow(windows, now);
    const tier = getVisibleTier(activeWindow, now);

    state.payload = payload;
    state.windowId = activeWindow && activeWindow.WindowId ? activeWindow.WindowId : '';
    state.tier = tier;
    state.expiresAt = tier && tier.ExpiresAt ? toDate(tier.ExpiresAt) : null;

    root.setAttribute('data-dt-window-id', state.windowId || '');

    if (tier) {
      updatePercent(root, tier);
      updateCouponTotal(root);
      updateTimer(root);
    } else {
      updateVisibility(root, false);
    }

    if (!state.busy) {
      syncRootWithCart(root);
    }

    if (!state.firstCartSyncDone) {
      root.style.visibility = 'hidden';
    }
  }

  function refreshAll() {
    document.querySelectorAll(config.rootSelector).forEach((root) => {
      refreshRoot(root);
    });
  }

  function tickAll() {
    document.querySelectorAll(config.rootSelector).forEach((root) => {
      updateTimer(root);
    });
  }

  function syncAllFromCart() {
    document.querySelectorAll(config.rootSelector).forEach((root) => {
      const state = getOrCreateState(root);
      if (!state.busy) {
        syncRootWithCart(root);
      }
    });
  }

  refreshAll();
  tickAll();
  syncAllFromCart();

  setInterval(refreshAll, config.refreshMs);
  setInterval(tickAll, config.timerMs);
  setInterval(syncAllFromCart, config.cartSyncMs);

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      refreshAll();
      tickAll();
      syncAllFromCart();
    }
  });

  window.addEventListener('pageshow', () => {
    refreshAll();
    tickAll();
    syncAllFromCart();
  });

  document.addEventListener('cart:refresh', syncAllFromCart, { passive: true });
  document.addEventListener(
    'sov:discount:changed',
    function () {
      refreshAll();
      syncAllFromCart();
    },
    { passive: true }
  ); 
  document.addEventListener('cart:updated', syncAllFromCart, { passive: true });

})();

/* sov coupon flag — json fetch only */
(function () {
  if (window.__SOV_coupon_flag_booted) return;
  window.__SOV_coupon_flag_booted = true;

  var SECTION_KEY = 'sov-coupon-flag-fetch';
  var ANCHOR_SEL  = '#sov-coupon-panel-anchor'; // fallback su fieldset se assente

  /* locale root resolver */
  function __normalizeLocaleTag(tag){try{var s=String(tag||'').trim().toLowerCase().replace('_','-');var m=s.match(/^([a-z]{2})(?:-([a-z]{2}))?$/);if(!m)return'';return m[2]?m[1]+'-'+m[2]:m[1];}catch(_){return'';}}
  function __computeLocaleRoot(){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    if(/^\/[a-z]{2}-[a-z]{2}\/$/.test(root))return root;
    var htmlLang=__normalizeLocaleTag(document.documentElement&&document.documentElement.lang);
    if(/^\/[a-z]{2}\/$/.test(root)&&/^([a-z]{2})-[a-z]{2}$/.test(htmlLang)){
      var langInRoot=root.slice(1,3); if(htmlLang.slice(0,2)===langInRoot) return '/'+htmlLang+'/';
    }
    return root.replace(/\/+$/,'/');
  }
  var LOCALE_ROOT = __computeLocaleRoot();

  function buildSectionsUrl(sectionKey, ctxPath){
    var base = LOCALE_ROOT.replace(/\/+$/,'/');
    var qs   = '?sections='+encodeURIComponent(sectionKey);
    if(ctxPath) qs += '&sections_url='+encodeURIComponent(ctxPath);
    return base + qs;
  }

  /* dom helpers */
  function findFieldset(){
    var a=document.querySelector(ANCHOR_SEL);
    if(a){ var fs=a.querySelector('.dt-fieldset'); if(fs) return fs; }
    return document.querySelector('.dt-fieldset[id^="dt-box-"]') || document.querySelector('.dt-fieldset');
  }
  function cmWrap(fs){ return fs ? (fs.closest('.sov-cm')||null) : null; }

  /* estrae json puro dall'html della section */
  function extractJsonFromSectionHtml(html){
    try{
      if(!html) return '';
      var t=String(html).trim();
      if(t[0]==='{' || t[0]==='[') return t; // già json
      var tmp=document.createElement('div');
      tmp.innerHTML=t;
      var wrap=tmp.querySelector('#shopify-section-'+SECTION_KEY) || tmp.firstElementChild || tmp;
      var text=(wrap && (wrap.textContent||wrap.innerText)||'').trim();
      if(text && (text[0]==='{' || text[0]==='[')) return text;
      // fallback duro: taglia tra primo { e ultima }
      var i=t.indexOf('{'), j=t.lastIndexOf('}');
      if(i!==-1 && j!==-1 && j>i) return t.slice(i,j+1).trim();
      return '';
    }catch(_){ return ''; }
  }

  /* decide visibilità dal json */
  function hasActiveWindowFromJson(raw){
    try{
      var data=JSON.parse(raw||'{}');
      var now=Date.now();
      if(Array.isArray(data.Windows)){
        return !!data.Windows.find(function(w){
          var s=w&&w.StartsAt?Date.parse(w.StartsAt):NaN;
          var e=w&&(w.BufferEndsAt||w.ExpiresAt)?Date.parse(w.BufferEndsAt||w.ExpiresAt):NaN;
          return !isNaN(s)&&!isNaN(e)&&now>=s&&now<=e;
        });
      }
      if(Array.isArray(data.Tiers)){
        return data.Tiers.some(function(t){
          if(t.Hidden===true) return false;
          var s=t.StartsAt?Date.parse(t.StartsAt):NaN;
          var e=t.ExpiresAt?Date.parse(t.ExpiresAt):NaN;
          if(isNaN(s)||isNaN(e)) return true;
          return now>=s&&now<=e;
        });
      }
      return false;
    }catch(_){ return false; }
  }

  /* telemetry impression (una volta) */
  function setupImpression(fs, raw){
    try{
      if(!fs || fs.__sovImprSent) return;
      var data=null; try{ data=JSON.parse(raw||'{}'); }catch(_){}
      var windowId='';
      if(data && (data.WindowId||data.windowId)) windowId=data.WindowId||data.windowId;
      if(!windowId && Array.isArray(data&&data.Windows)){
        var now=Date.now();
        for(var i=0;i<data.Windows.length;i++){
          var w=data.Windows[i], s=w&&w.StartsAt?Date.parse(w.StartsAt):NaN, e=w&&w.BufferEndsAt?Date.parse(w.BufferEndsAt):NaN;
          if(!isNaN(s)&&!isNaN(e)&&now>=s&&now<=e){ windowId=w.WindowId||w.Id||''; if(windowId)break; }
        }
      }
      var tiers=[];
      if(Array.isArray(data&&data.Tiers)){
        data.Tiers.forEach(function(t){ if(t && t.Hidden!==true) tiers.push((t.Tier||'')+':'+(t.Percent||'')); });
      }
      if(typeof gtag==='function'){
        fs.__sovImprSent=true;
        gtag('event','pdp_coupon_flag_impression',{
          window_id: windowId||'',
          tiers: tiers.join('|'),
          tiers_count: tiers.length||0,
          position: 'pdp_accordion',
          locale: (window.Shopify&&Shopify.locale) || (document.documentElement&&document.documentElement.lang) || '',
          currency: (window.Shopify&&Shopify.currency&&Shopify.currency.active)||'',
          product_id: (window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product&&ShopifyAnalytics.meta.product.id)||'',
          variant_id: (document.querySelector('[name="id"]')&&document.querySelector('[name="id"]').value)||''
        });
      }
    }catch(_){}
  }

  /* applica json al fieldset + mostra/nasconde */
function applyRaw(fs, raw){
  if(!fs) return;
  fs.setAttribute('data-dt-payload', raw || '');
  // visibilità flag gestita in pdp
  if (typeof window.__DT_populateCouponsFromJson === 'function') {
    window.__DT_populateCouponsFromJson();
  }
}

/* --- impression wiring (una volta quando il flag è realmente visibile) --- */
function isElVisibleOnScreen(el){
  if(!el) return false;
  var cs = getComputedStyle(el);
  if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
  var r = el.getBoundingClientRect();
  var vh = window.innerHeight || document.documentElement.clientHeight;
  var vw = window.innerWidth  || document.documentElement.clientWidth;
  return r.width > 0 && r.height > 0 && r.bottom > 0 && r.right > 0 && r.top < vh && r.left < vw;
}

function ensureImpressionIfNeeded(fs){
  try{
    if(!fs || fs.__sovImprSent) return;
    var raw = fs.getAttribute('data-dt-payload') || '';
    if(!hasActiveWindowFromJson(raw)) return;
    if(!isElVisibleOnScreen(fs)) return;
    setupImpression(fs, raw);
  }catch(_){}
}

function bindImpressionWatch(fs){
  if(!fs || fs.__sovImprBound) return;
  fs.__sovImprBound = true;

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting) ensureImpressionIfNeeded(fs); });
  }, { threshold: 0.01 });
  io.observe(fs);
  fs.__sovIo = io;

  var mo = new MutationObserver(function(){ ensureImpressionIfNeeded(fs); });
  mo.observe(fs, { attributes:true, attributeFilter:['style','class','data-dt-visible','data-dt-payload'] });
  var cm = cmWrap(fs);
  if (cm) mo.observe(cm, { attributes:true, attributeFilter:['style','class'] });

  setTimeout(function(){ ensureImpressionIfNeeded(fs); }, 300);
}
/* --- fine impression wiring --- */

  function fetchAndApply(){
    var fs=findFieldset(); if(!fs) return;
    var url=buildSectionsUrl(SECTION_KEY, location.pathname);
    fetch(url,{credentials:'same-origin',cache:'no-store'})
      .then(function(r){return r.ok?r.json():{};})
      .then(function(obj){
        var html = obj && obj[SECTION_KEY] ? String(obj[SECTION_KEY]) : '';
        var raw  = extractJsonFromSectionHtml(html);
        applyRaw(fs, raw);
        bindImpressionWatch(fs); // attiva observer e invio impression quando il flag entra in viewport
      })
      .catch(function(){ /* silent */ });
  }

  function start(){
    var fs=findFieldset();
    if(!fs){ setTimeout(start,120); return; }
    fetchAndApply();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();

  ['page:load','shopify:section:load'].forEach(function(ev){
    document.addEventListener(ev, function(){ fetchAndApply(); }, {passive:true});
  });
  window.addEventListener('popstate', function(){ fetchAndApply(); }, {passive:true});

  /* polling leggero per cache + countdown */
  setInterval(fetchAndApply, 15000);
})();


/*bubble sconti*/
  (() => {
    if (window.__sovCouponBubbleBooted) {
      return;
    }
    window.__sovCouponBubbleBooted = true;
    
    function prefersReduced() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function getHeaderH() {
      const h =
        document.querySelector('.header-wrapper') ||
        document.querySelector('header') ||
        document.querySelector('.shopify-section-header');
      return h ? Math.round(h.getBoundingClientRect().height) : 0;
    }

    function findCouponTarget() {
      return (
        document.querySelector('.dt-fieldset') ||
        document.querySelector('[id^="dt-box-"]') ||
        document.getElementById('sov-coupon-panel-anchor')
      );
    }

     function isVisible(el) {
      return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
    }

    function pulseCoupon(el) {
      if (!el) return;

      const list = el.querySelector('ul.dt-list') || el;

      list.classList.remove('sov-coupon-pulse');
      void list.offsetWidth;
      list.classList.add('sov-coupon-pulse');

      setTimeout(() => {
        list.classList.remove('sov-coupon-pulse');
      }, 2700);
    }


    function scrollToCoupons() {
      const t = findCouponTarget();
      if (!t) return;

      const r = t.getBoundingClientRect();
      const headerH = getHeaderH();
      const vh = window.innerHeight || document.documentElement.clientHeight || 0;

      const mid = headerH + (vh - headerH) / 2;
      const top = Math.max(0, window.scrollY + r.top + (r.height / 2) - mid);

      window.scrollTo({
        top,
        behavior: prefersReduced() ? 'auto' : 'smooth'
      });

      setTimeout(() => {
        pulseCoupon(t);
      }, prefersReduced() ? 0 : 480);
    }


    function init() {
      const btn = document.querySelector('.sov-discount-bubble');
      if (!btn) return;
      

        function syncBubbleHiddenState() {
        const t = findCouponTarget();

        if (!t) {
          btn.toggleAttribute('hidden', true);
          btn.classList.add('is-hidden');
          return;
        }

        btn.toggleAttribute('hidden', false);

        const headerH = getHeaderH();
        const r = btn.getBoundingClientRect();

        const hideForHeader = r.top <= headerH + 6;
        const hideForCoupons = !isVisible(t);

        btn.classList.toggle('is-hidden', hideForHeader || hideForCoupons);
      }

      let raf = 0;
      function scheduleSyncBubbleHidden() {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          syncBubbleHiddenState();
        });
      }

      scheduleSyncBubbleHidden();

      window.addEventListener('scroll', scheduleSyncBubbleHidden, { passive: true });
      window.addEventListener('resize', scheduleSyncBubbleHidden, { passive: true });

      document.addEventListener('cart:refresh', scheduleSyncBubbleHidden, { passive: true });
      document.addEventListener('cart:updated', scheduleSyncBubbleHidden, { passive: true });
      window.addEventListener('pageshow', scheduleSyncBubbleHidden, { passive: true });

      (function bindCouponTargetObserver() {
        const t = findCouponTarget();
        if (!t || t.__sovBubbleObs) return;
        t.__sovBubbleObs = true;

        if (!window.MutationObserver) return;

        const mo = new MutationObserver(function () {
          scheduleSyncBubbleHidden();
        });

        mo.observe(t, {
          attributes: true,
          attributeFilter: ['style', 'class', 'data-dt-visible', 'hidden']
        });

        const cm = t.closest && t.closest('.sov-cm');
        if (cm) {
          mo.observe(cm, {
            attributes: true,
            attributeFilter: ['style', 'class']
          });
        }
      })();



      function setExpandedWidth() {
	var icon = btn.querySelector('.sov-discount-bubble__icon');
	var text = btn.querySelector('.sov-discount-bubble__text');

	if (!icon || !text) {
		return;
	}

	var cs = getComputedStyle(btn);

	var pl = parseFloat(cs.paddingLeft) || 0;
	var pr = parseFloat(cs.paddingRight) || 0;
	var bl = parseFloat(cs.borderLeftWidth) || 0;
	var br = parseFloat(cs.borderRightWidth) || 0;

	var gap = parseFloat(cs.gap) || parseFloat(cs.columnGap) || 0;

	var iconW = Math.ceil(icon.getBoundingClientRect().width);
	var textW = Math.ceil(text.scrollWidth);

	var w = pl + pr + bl + br + iconW + gap + textW;

	if (w < 44) {
		w = 44;
	}

	btn.style.setProperty('--sov-discount-expanded-w', Math.ceil(w) + 'px');
}

setExpandedWidth();

if (document.fonts && document.fonts.ready) {
	document.fonts.ready
		.then(function () {
			setExpandedWidth();
		})
		.catch(function () {});
}

window.addEventListener(
	'resize',
	function () {
		setExpandedWidth();
	},
	{ passive: true }
);


      function syncVisibility() {
        scheduleSyncBubbleHidden();
      }

      btn.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          scrollToCoupons();
        },
        { passive: false }
      );

      let tries = 0;
      (function retry() {
        syncVisibility();
        tries += 1;
        if (tries < 6) setTimeout(retry, 350);
      })();

      if (prefersReduced()) return;

      setTimeout(() => {
        if (btn.hasAttribute('hidden')) return;
        if (btn.classList.contains('is-hidden')) return;
        btn.classList.add('is-expanded');
        setTimeout(() => btn.classList.remove('is-expanded'), 2200);
      }, 120);
    }


    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();

/*fine bubble sconti */

/*calcolo sconto*/
/* sov — prezzo con coupon: percentuale + link dettagli (timer spostato in modale) */
(function () {
  if (window.__sovCouponPriceBooted) {
  return;
}
window.__sovCouponPriceBooted = true;

  var last = {
    code: null,
    percent: 0,
    expiresAt: null,
    tier: '',
    windowId: '',
    endMs: null
  };
  var shouldShowInlineCouponTimer = true;
  var firstLine = document.querySelector('.price-line-first');
  var secondLine = document.querySelector('.price-line-second');

  var discValueEl = document.querySelector('.price-item.price-item--regular.price-item--discounted');
  var discCurrEl = document.querySelector('.currency-symbol.price-item--discounted');
  var pillEl = firstLine && firstLine.querySelector('.price-coupon-code-pill');

  var regularWrap = secondLine && secondLine.querySelector('.price-item.price-item--regular');
  var regularValueEl = regularWrap && regularWrap.querySelector('.price-value');
  var regularCurrEl = regularWrap && regularWrap.querySelector('.currency-symbol');

  if (
    !firstLine ||
    !secondLine ||
    !discValueEl ||
    !discCurrEl ||
    !pillEl ||
    !regularWrap ||
    !regularValueEl ||
    !regularCurrEl
  ) {
    console.warn('[price-coupon] markup non trovato');
    return;
  }

  function setFirstLineVisible(v) {
    firstLine.style.display = v ? 'flex' : 'none';
  }

  function formatAsHHMMSS(totalSeconds) {
  var s = Math.max(0, Math.floor(totalSeconds));
  var h = Math.floor(s / 3600);
  var m = Math.floor((s % 3600) / 60);
  var r = s % 60;

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  return pad2(h) + ':' + pad2(m) + ':' + pad2(r);
}


  function derivePattern(sampleStr) {
    var s = String(sampleStr || '').trim();
    var lastSepIdx = -1;

    for (var i = s.length - 1; i >= 0; i--) {
      var ch = s.charAt(i);
      if (ch < '0' || ch > '9') {
        lastSepIdx = i;
        break;
      }
    }

    var decimalSep = '';
    var decimals = 0;

    if (lastSepIdx >= 0) {
      var after = s.slice(lastSepIdx + 1).replace(/[^\d]/g, '');
      if (after.length > 0 && after.length !== 3) {
        decimalSep = s.charAt(lastSepIdx);
        decimals = after.length;
      }
    }

    var intPartStr = decimals > 0 ? s.slice(0, lastSepIdx) : s;
    var groupSep = '';

    for (var j = 0; j < intPartStr.length; j++) {
      var c = intPartStr.charAt(j);
      if (c < '0' || c > '9') {
        groupSep = c;
        break;
      }
    }

    return { decimalSep: decimalSep, groupSep: groupSep, decimals: decimals };
  }

  function parseFromSample(sampleStr) {
    var p = derivePattern(sampleStr);
    var s = String(sampleStr || '').trim();

    if (p.groupSep) s = s.split(p.groupSep).join('');
    if (p.decimals > 0 && p.decimalSep) s = s.split(p.decimalSep).join('.');

    s = s.replace(/[^\d.-]/g, '');
    var n = parseFloat(s);

    return isNaN(n) ? 0 : n;
  }

  function formatLikeSample(sampleStr, number) {
    var p = derivePattern(sampleStr);
    var sign = number < 0 ? '-' : '';
    var abs = Math.abs(number);
    var fixed = p.decimals > 0 ? abs.toFixed(p.decimals) : Math.round(abs).toString();
    var parts = fixed.split('.');
    var intPart = parts[0];
    var decPart = parts[1];

    if (p.groupSep) {
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(intPart)) intPart = intPart.replace(rgx, '$1' + p.groupSep + '$2');
    }

    var out = decPart != null ? intPart + (p.decimalSep || ',') + decPart : intPart;
    return sign + out;
  }

  var baseSample = regularValueEl.textContent || '';
  var basePrice = parseFromSample(baseSample);
  regularWrap.dataset.basePrice = String(basePrice);
  regularWrap.dataset.baseSample = baseSample;
  updateCouponFlagSavingsLine();
  
  pillEl.innerHTML = '';

var pillPercentEl = document.createElement('span');
pillPercentEl.className = 'pill-percent';

var pillTimerEl = null;
if (shouldShowInlineCouponTimer) {
  pillTimerEl = document.createElement('span');
  pillTimerEl.className = 'pill-timer';
  pillTimerEl.hidden = true;
}

var detailsLabelSource = document.querySelector('.dt-fieldset[data-details-label]');
var detailsLabel =
  (detailsLabelSource &&
    String(detailsLabelSource.getAttribute('data-details-label') || '').trim()) ||
  'Details';

var pillDetailsLink = (function () {
  var a =
    document.querySelector('.sov-coupon-link-details') ||
    document.querySelector('.sov-open-pdp_coupon');

  if (a) return a.cloneNode(true);

  var b = document.createElement('a');
  b.href = '#';
  b.className = 'sov-open-pdp_coupon sov-coupon-link-details';
  b.setAttribute('role', 'button');
  b.setAttribute('aria-haspopup', 'dialog');
  b.setAttribute('aria-controls', 'pdp-modale-dettagli-coupon-overlay');
  b.setAttribute('aria-expanded', 'false');
  b.textContent = detailsLabel;
  return b;
})();

pillEl.appendChild(pillPercentEl);

if (pillTimerEl) {
  pillEl.appendChild(document.createTextNode(' '));
  pillEl.appendChild(pillTimerEl);
}

pillEl.appendChild(document.createTextNode(' '));
pillEl.appendChild(pillDetailsLink);


  var __expiryCheckId = null;
  var __couponEndMs = NaN;

  function normalizeCouponLocaleTag(tag) {
    try {
      var value = String(tag || '').trim().toLowerCase().replace('_', '-');
      var match = value.match(/^([a-z]{2})(?:-([a-z]{2}))?$/);
      if (!match) return '';
      return match[2] ? match[1] + '-' + match[2] : match[1];
    } catch (_) {
      return '';
    }
  }

  function getCouponLocaleRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    if (/^\/[a-z]{2}-[a-z]{2}\/$/.test(root)) {
      return root;
    }

    var htmlLang = normalizeCouponLocaleTag(document.documentElement && document.documentElement.lang);

    if (/^\/[a-z]{2}\/$/.test(root) && /^([a-z]{2})-[a-z]{2}$/.test(htmlLang)) {
      var langInRoot = root.slice(1, 3);
      if (htmlLang.slice(0, 2) === langInRoot) {
        return '/' + htmlLang + '/';
      }
    }

    return root.replace(/\/+$/, '/');
  }

  function buildCouponStoreUrl(path) {
    var cleanPath = String(path || '').replace(/^\/+/, '');
    return getCouponLocaleRoot() + cleanPath;
  }

    function normalizeCouponLocaleTag(tag) {
    try {
      var value = String(tag || '').trim().toLowerCase().replace('_', '-');
      var match = value.match(/^([a-z]{2})(?:-([a-z]{2}))?$/);
      if (!match) return '';
      return match[2] ? match[1] + '-' + match[2] : match[1];
    } catch (_) {
      return '';
    }
  }

  function getCouponLocaleRoot() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    if (/^\/[a-z]{2}-[a-z]{2}\/$/.test(root)) {
      return root;
    }

    var htmlLang = normalizeCouponLocaleTag(
      document.documentElement && document.documentElement.lang
    );

    if (/^\/[a-z]{2}\/$/.test(root) && /^([a-z]{2})-[a-z]{2}$/.test(htmlLang)) {
      var langInRoot = root.slice(1, 3);
      if (htmlLang.slice(0, 2) === langInRoot) {
        return '/' + htmlLang + '/';
      }
    }

    return root.replace(/\/+$/, '/');
  }

  function buildCouponStoreUrl(path) {
    var cleanPath = String(path || '').replace(/^\/+/, '');
    return getCouponLocaleRoot() + cleanPath;
  }

  function removeAllDiscounts() {
    return fetch(buildCouponStoreUrl('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: '' })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('discount remove failed');
      }
      return response.json().catch(function () {
        return null;
      });
    });
  }

  function getCouponCartDrawerElement() {
    return (
      document.querySelector('cart-drawer') ||
      document.getElementById('CartDrawer') ||
      document.querySelector('.cart-drawer')
    );
  }

  async function forceRefreshCouponCartDrawer() {
    var ctxPath = window.location.pathname + window.location.search;
    var url =
      buildCouponStoreUrl('') +
      '?sections=' +
      encodeURIComponent('cart-drawer') +
      ',' +
      encodeURIComponent('cart-icon-bubble') +
      '&sections_url=' +
      encodeURIComponent(ctxPath);

    var response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('cart drawer refresh failed');
    }

    var sections = await response.json();
    var drawer = getCouponCartDrawerElement();

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: sections });
    } else {
      var drawerSection = document.getElementById('shopify-section-cart-drawer');
      if (drawerSection && sections['cart-drawer']) {
        drawerSection.innerHTML = sections['cart-drawer'];
      }
    }

    var bubbleSection = document.getElementById('shopify-section-cart-icon-bubble');
    if (bubbleSection && sections['cart-icon-bubble']) {
      bubbleSection.innerHTML = sections['cart-icon-bubble'];
    }

    renderCouponExpiredNoticeInCartDrawerFooter();
  } 

  var SOV_COUPON_EXPIRED_NOTICE_KEY = 'sov_coupon_expired_notice';

  function markCouponExpiredNoticePending() {
    try {
      sessionStorage.setItem(
        SOV_COUPON_EXPIRED_NOTICE_KEY,
        JSON.stringify({ ts: Date.now() })
      );
    } catch (e) {}
  }

  function consumeCouponExpiredNoticePending() {
    try {
      var raw = sessionStorage.getItem(SOV_COUPON_EXPIRED_NOTICE_KEY);
      if (!raw) return false;

      sessionStorage.removeItem(SOV_COUPON_EXPIRED_NOTICE_KEY);
      return true;
    } catch (e) {
      return false;
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function renderCouponExpiredNoticeInCartDrawerFooter() {
    var host = document.querySelector('.sov-cart-drawer-notices');
    if (!host) return;

    if (!consumeCouponExpiredNoticePending()) {
      host.hidden = true;
      host.innerHTML = '';
      return;
    }

    var title = host.getAttribute('data-coupon-expired-title') || 'Coupon expired';
    var text =
      host.getAttribute('data-coupon-expired-text') ||
      'The previous coupon is no longer active';

    host.innerHTML =
      '<div class="sov-cart-drawer-notice">' +
        '<p class="sov-cart-drawer-notice__title">' + escapeHtml(title) + '</p>' +
        '<p class="sov-cart-drawer-notice__text">' + escapeHtml(text) + '</p>' +
      '</div>';

    host.hidden = false;
  }

  window.__sovForceRefreshCouponCartDrawer = forceRefreshCouponCartDrawer;

  async function onCouponExpiredPdp() {
    try {
      await removeAllDiscounts();
    } catch (e) {
      return;
    }

    markCouponExpiredNoticePending();

    try {
      await forceRefreshCouponCartDrawer();
    } catch (e) {}

    try {
      document.dispatchEvent(
        new CustomEvent('sov:discount:changed', {
          detail: {
            code: '',
            percent: 0,
            expiresAt: '',
            tier: '',
            windowId: ''
          }
        })
      );
    } catch (e) {}

    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {}

    try {
      applyDiscountUI(null, 0, null);
    } catch (e) {}
  }

  function applyDiscountUI(code, percent, expiresAt) {
    percent = Number(percent);
    last.code = code || null;
    last.percent = percent || 0;
    last.expiresAt = expiresAt || null;

    last.endMs = expiresAt ? Date.parse(expiresAt) : null;

    if (__expiryCheckId) {
      clearInterval(__expiryCheckId);
      __expiryCheckId = null;
    }

    if (!percent || percent <= 0) {
      setFirstLineVisible(false);
      discValueEl.hidden = true;
      discCurrEl.hidden = true;
      pillEl.hidden = true;
      pillPercentEl.textContent = '';
      if (pillTimerEl) {
  pillTimerEl.textContent = '';
  pillTimerEl.hidden = true;
}

      regularWrap.classList.remove('has-coupon-applied');

      var baseCents2 = Math.round(basePrice * 100);
      regularValueEl.textContent = formatLikeSample(baseSample, baseCents2 / 100);
      return;
    }

    var baseCents = Math.round(basePrice * 100);
    var discCents = baseCents - Math.floor((baseCents * percent) / 100);
    var discounted = discCents / 100;

    discValueEl.textContent = formatLikeSample(baseSample, discounted);
    discCurrEl.textContent = regularCurrEl.textContent || '';
    discValueEl.hidden = false;
    discCurrEl.hidden = false;

    pillPercentEl.textContent = '−' + percent + '%';

__couponEndMs = expiresAt ? Date.parse(expiresAt) : NaN;
last.endMs = isNaN(__couponEndMs) ? null : __couponEndMs;

if (pillTimerEl) {
  pillTimerEl.textContent = '';
  pillTimerEl.hidden = true;
}

if (!isNaN(__couponEndMs)) {
  __expiryCheckId = setInterval(function () {
    var leftMs = __couponEndMs - Date.now();

    if (leftMs <= 0) {
      if (pillTimerEl) {
        pillTimerEl.textContent = '00:00:00';
        pillTimerEl.hidden = true;
      }

      clearInterval(__expiryCheckId);
      __expiryCheckId = null;
      onCouponExpiredPdp();
      return;
    }

    if (pillTimerEl) {
      var leftSec = Math.ceil(leftMs / 1000);
      pillTimerEl.textContent = formatAsHHMMSS(leftSec);
      pillTimerEl.hidden = false;
    }
  }, 1000);
}


    pillEl.hidden = false;
    regularWrap.classList.add('has-coupon-applied');
    setFirstLineVisible(true);
  }

function computeCouponTotalValueCentsFromBaseCentsAndPercent(baseCentsLocal, pct)
{
	var p = Number(pct) || 0;
	if (p <= 0) return baseCentsLocal;

	var saveCents = Math.floor((baseCentsLocal * p) / 100);
	return baseCentsLocal - saveCents;
}

function formatCouponTotalValueTextFromPercent(pct)
{
	var baseCentsLocal = Math.round(basePrice * 100);
	var totalCents = computeCouponTotalValueCentsFromBaseCentsAndPercent(baseCentsLocal, pct);

	var amount = formatLikeSample(baseSample, totalCents / 100);
	var curr = regularCurrEl ? String(regularCurrEl.textContent || '').trim() : '';

	return {
		totalCents: totalCents,
		text: curr ? (amount + ' ' + curr) : amount
	};
}

function updateCouponFlagSavingsLine()
{
	var fieldset = document.querySelector('.dt-fieldset[data-dt-visible="1"][data-dt-payload]');
	if (!fieldset) return;

	var line = fieldset.querySelector('[data-dt-savings-line]');
	var amountEl = fieldset.querySelector('[data-dt-savings-amount]');
	if (!line || !amountEl) return;

	var totalEl = fieldset.querySelector('[data-dt-coupon-total-amount]');
	if (totalEl) totalEl.hidden = true;

	var pctEl = fieldset.querySelector('#coupon-vip .dt-pct');
	var m = pctEl ? String(pctEl.textContent || '').match(/(\d{1,3})/) : null;
	var pct = m ? parseInt(m[1], 10) : 0;

	if (!pct || pct <= 0) {
		line.hidden = true;
		return;
	}

	if (typeof basePrice !== 'number' || isNaN(basePrice) || basePrice <= 0) {
		line.hidden = true;
		return;
	}

	var baseCentsLocal = Math.round(basePrice * 100);
	var saveCents = Math.floor((baseCentsLocal * pct) / 100);

	if (!saveCents || saveCents <= 0) {
		line.hidden = true;
		return;
	}

	var amount = formatLikeSample(baseSample, saveCents / 100);
	var curr = regularCurrEl ? String(regularCurrEl.textContent || '').trim() : '';

	amountEl.textContent = curr ? (amount + ' ' + curr) : amount;
	line.hidden = false;

	var totalObj = formatCouponTotalValueTextFromPercent(pct);

	fieldset.dataset.dtCouponTotalCents = String(totalObj.totalCents);

	if (totalEl) {
		totalEl.textContent = totalObj.text;
		totalEl.hidden = false;
	}
}



  function refreshBaseFromDom() {
    var sampleNow = regularValueEl.textContent || '';
    if (!sampleNow || sampleNow === baseSample) return false;

    baseSample = sampleNow;
    basePrice = parseFromSample(sampleNow);
    regularWrap.dataset.basePrice = String(basePrice);
    regularWrap.dataset.baseSample = baseSample;
    return true;
  }

  document.addEventListener(
    'sov:discount:applied',
    function (e) {
      var d = (e && e.detail) || {};
      last.tier = d.Tier || d.tier || last.tier || '';
      last.windowId = d.WindowId || d.windowId || last.windowId || (window.__dt_currentWindowId || '');
      try {
        applyDiscountUI(d.code, d.percent, d.expiresAt);
        updateCouponFlagSavingsLine();
      } catch (err) {
        console.warn('[price-coupon] errore aggiorna ui', err);
      }
    },
    { passive: true }
  );

  window.addEventListener(
    'variantGalleryUpdated',
    function () {
      requestAnimationFrame(function () {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'variant:changed',
    function () {
      requestAnimationFrame(function () {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'product:variant:change',
    function () {
      requestAnimationFrame(function () {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
      });
    },
    { passive: true }
  );

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].type === 'characterData' || muts[i].type === 'childList') {
        if (refreshBaseFromDom()) applyDiscountUI(last.code, last.percent, last.expiresAt);
        updateCouponFlagSavingsLine();
        break;
      }
    }
  });

  mo.observe(regularValueEl, { characterData: true, subtree: true, childList: true });

  setFirstLineVisible(false);
})();

/* sov — pdp coupon modal details binder
   ultimo aggiornamento: 2026-03-04 europe/rome
*/
(function () {
	'use strict';
  if (window.__sovCouponModalBooted) {
    return;
  }
  window.__sovCouponModalBooted = true;
	var OVERLAY_ID = 'sov-modal-pdp_coupon-overlay';

	var overlay = null;
	var tickId = null;
	var endMs = 0;

	function qs(root, sel) {
		return root ? root.querySelector(sel) : null;
	}

	function getOverlay() {
		return document.getElementById(OVERLAY_ID);
	}

	function getFieldsetId() {
		if (!overlay) return '';
		return overlay.getAttribute('data-sov-coupon-fieldset-id') || '';
	}

	function getExpiredLabel() {
		if (!overlay) return 'Expired';
		return overlay.getAttribute('data-sov-expired-label') || 'Expired';
	}

	function getFieldset() {
		var id = getFieldsetId();
		if (id) {
			return document.getElementById(id);
		}
		return document.querySelector('.dt-fieldset');
	}

	function parsePayloadFromFieldset(fs) {
		if (!fs) return null;

		var raw =
			fs.getAttribute('data-dt-payload') ||
			(fs.dataset ? fs.dataset.dtPayload : '') ||
			'';

		raw = String(raw || '')
			.replace(/&quot;/g, '"')
			.replace(/&#39;/g, "'");

		if (!raw) return null;

		try {
			return JSON.parse(raw);
		} catch (e) {
			return null;
		}
	}

	function pickActiveWindow(schedule) {
		if (!schedule || !Array.isArray(schedule.Windows)) return null;

		var now = Date.now();

		for (var i = 0; i < schedule.Windows.length; i++) {
			var w = schedule.Windows[i] || {};
			var s = w.StartsAt ? Date.parse(w.StartsAt) : NaN;
			var e = w.BufferEndsAt ? Date.parse(w.BufferEndsAt) : (w.ExpiresAt ? Date.parse(w.ExpiresAt) : NaN);

			if (!isNaN(s) && !isNaN(e) && now >= s && now < e) {
				return w;
			}
		}

		return schedule.Windows[0] || null;
	}

	function findTier(win) {
		if (!win || !Array.isArray(win.Tiers)) return null;

		var tmax = null;
		for (var i = 0; i < win.Tiers.length; i++) {
			var t = win.Tiers[i] || {};
			if (t.Hidden === true) continue;
			if (String(t.Tier || '').toLowerCase() === 'tmax') {
				tmax = t;
				break;
			}
		}

		if (tmax) return tmax;

		for (var j = 0; j < win.Tiers.length; j++) {
			var t2 = win.Tiers[j] || {};
			if (t2.Hidden === true) continue;
			return t2;
		}

		return null;
	}

	function fmtCountdown(ms) {
		var s = Math.max(0, Math.floor(ms / 1000));
		var h = Math.floor(s / 3600);
		var m = Math.floor((s % 3600) / 60);
		var ss = s % 60;

		return (
			String(h).padStart(2, '0') +
			':' +
			String(m).padStart(2, '0') +
			':' +
			String(ss).padStart(2, '0')
		);
	}

	function fmtLocal(iso) {
		try {
			var d = new Date(iso);
			return new Intl.DateTimeFormat(undefined, {
				dateStyle: 'medium',
				timeStyle: 'short',
			}).format(d);
		} catch (e) {
			return String(iso || '');
		}
	}

	function stopTick() {
		if (tickId) {
			clearInterval(tickId);
			tickId = null;
		}
		endMs = 0;
	}

	function startTick(timerEl) {
		stopTick();

		if (!timerEl || !endMs) return;

		function tick() {
			var left = endMs - Date.now();

			if (left <= 0) {
				timerEl.textContent = getExpiredLabel();
				stopTick();
				return;
			}

			timerEl.textContent = fmtCountdown(left);
		}

		tick();
		tickId = setInterval(tick, 1000);
	}

	function render() {
		if (!overlay) return;

		var codeEl = qs(overlay, '.dt-code');
		var expEl = qs(overlay, '.dt-expires-at');
		var timerEl = qs(overlay, '.dt-timer');

		if (codeEl) codeEl.textContent = '—';
		if (expEl) expEl.textContent = '—';
		if (timerEl) timerEl.textContent = '--:--:--';

		var fs = getFieldset();
		var payload = parsePayloadFromFieldset(fs);
		if (!payload) {
			stopTick();
			return;
		}

		var win = Array.isArray(payload.Windows) ? pickActiveWindow(payload) : payload;
		if (!win) {
			stopTick();
			return;
		}

		var tier = findTier(win);
		if (!tier) {
			stopTick();
			return;
		}

		var expiresAt = tier.ExpiresAt || win.ExpiresAt || win.BufferEndsAt || '';
		var code = tier.Code || '';

		if (codeEl) codeEl.textContent = String(code || '—');
		if (expEl) expEl.textContent = expiresAt ? fmtLocal(expiresAt) : '—';

		endMs = expiresAt ? Date.parse(expiresAt) : 0;
		if (!endMs || isNaN(endMs)) {
			stopTick();
			return;
		}

		startTick(timerEl);
	}

	function isActive() {
		return overlay && overlay.classList && overlay.classList.contains('active');
	}

	function onActiveChange() {
		if (!overlay) return;

		if (isActive()) {
			render();
			return;
		}

		stopTick();
	}

	function bind() {
		overlay = getOverlay();
		if (!overlay) return;

		try {
			overlay.addEventListener('sov:modal:closed', function () {
				stopTick();
			});
		} catch (e) {}

		if (window.MutationObserver) {
			var mo = new MutationObserver(function () {
				onActiveChange();
			});

			mo.observe(overlay, {
				attributes: true,
				attributeFilter: ['class'],
			});
		}

		onActiveChange();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', bind);
	} else {
		bind();
	}
})();

